import Swiper, { Navigation, Pagination, Manipulation } from "swiper";
import { initIntersectionObserver } from "@plugins";

const otherArticles = document.querySelector(".js-articles-other-swiper");

if (otherArticles) {
    initIntersectionObserver(otherArticles, initOtherArticlesSlider);
}

function initOtherArticlesSlider(swiperContainer) {
    new Swiper(swiperContainer, {
        modules: [Navigation, Pagination, Manipulation],
        slidesPerView: 1.7,
        spaceBetween: 17,
        pagination: {
            el: ".js-articles-other-controls > .swiper-pagination",
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
            type: "progressbar",
        },
        navigation: {
            nextEl: ".js-articles-other-controls > .swiper-button-next",
            prevEl: ".js-articles-other-controls > .swiper-button-prev",
        },
        observer: true,
        watchOverflow: true,
        breakpoints: {
            567: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
}
